(function () {
  var VARIANT_MAP = {
    '382': 53655050617139,
    '383': 53980172943667,
    '384': 53980172976435
  };

  // Shipping-protection add-on (Priority Insured Shipping, $4.95) -- added
  // to every order alongside whatever tier the visitor selects, regardless
  // of quantity/tier, same as every other CC-clone product on this store.
  var SHIPPING_PROTECTION_VARIANT_ID = 53646568128819;

  // Any tier's variant can independently be switched to subscription-only
  // (requiresSellingPlan: true) by the store's subscription app (Loop).
  // Submitting a required-selling-plan variant with no selling_plan fails
  // Shopify's cart validation with a 422 "Cart Error: Variant can only be
  // purchased with a selling plan," which renders as Shopify's own generic
  // full-page error. The required plan ID is NOT stable -- it belongs to
  // whichever subscription app currently manages the product, and
  // reconfiguring a tier (or swapping apps) provisions a brand new ID for
  // the same variant (confirmed live on rnmn-cc-clone-interactions.js,
  // 2026-08-31: broke 3 times in one day across 3 different tiers before
  // this dynamic-lookup pattern replaced the hardcoded-ID approach). So:
  // look up whether the SELECTED variant currently requires a selling
  // plan, and which plan ID to use, live from Shopify's own public
  // product AJAX endpoint (/products/{handle}.js) at the moment of an
  // actual click -- never assume it's still whatever it was on the last
  // deploy. Keyed by variant ID -> product handle (handles are stable;
  // plan IDs aren't). Cached in-memory per page load so re-clicking the
  // same tier doesn't refetch.
  var PRODUCT_HANDLE_MAP = {
    '53655050617139': 'acrom-superbalance™-hormonal-support-drink-mix-buy-1-get-1',
    '53980172943667': 'acrom-superbalance™-hormonal-support-drink-mix-buy-2-get-1',
    '53980172976435': 'acrom-superbalance™-hormonal-support-drink-mix-buy-3-get-2'
  };
  var sellingPlanCache = {};
  function getRequiredSellingPlan(variantId) {
    if (Object.prototype.hasOwnProperty.call(sellingPlanCache, variantId)) {
      return Promise.resolve(sellingPlanCache[variantId]);
    }
    var handle = PRODUCT_HANDLE_MAP[variantId];
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var variant = (product.variants || []).filter(function (v) { return v.id === variantId; })[0];
        var planId = null;
        if (variant && variant.requires_selling_plan && product.selling_plan_groups && product.selling_plan_groups.length) {
          var plan = product.selling_plan_groups[0].selling_plans && product.selling_plan_groups[0].selling_plans[0];
          if (plan) planId = plan.id;
        }
        sellingPlanCache[variantId] = planId;
        return planId;
      })
      .catch(function () { return null; });
  }

  function getCheckedRadio() {
    return document.querySelector('.fk-product-radio:checked');
  }

  function getSelectedVariantId() {
    var checked = getCheckedRadio();
    if (!checked) return null;
    return VARIANT_MAP[checked.value] || null;
  }

  function syncActiveStyling() {
    document.querySelectorAll('.fk-product-radio').forEach(function (radio) {
      var block = radio.parentElement && radio.parentElement.querySelector('.product-selector_block');
      if (!block) return;
      block.classList.toggle('active', radio.checked);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('fk-product-radio')) {
      syncActiveStyling();
    }
  });

  function setAtcLoading(btn, loading) {
    if (!btn) return;
    btn.style.pointerEvents = loading ? 'none' : '';
    btn.style.opacity = loading ? '0.6' : '';
    btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
    btn.textContent = loading ? 'Adding...' : btn.dataset.originalText;
  }

  // Safari/Firefox/Chrome all restore this page from the back-forward
  // cache (bfcache) -- not a fresh reload -- when the customer hits Back
  // from /checkout. That restores the DOM exactly as it was the instant
  // they left, including whatever inline state setAtcLoading(btn, true)
  // left on the ATC button (pointer-events:none, "Adding..." text). With
  // no reset, the button is permanently inert after every back-navigation.
  // event.persisted is true specifically for a bfcache restore, so reset
  // every ATC button's loading state only in that case.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      setAtcLoading(btn, false);
    });
  });

  // Retries a fetch once/twice with a backoff on a 429 (rate limited) or
  // 5xx response, or a network-level failure -- a safety net for the rarer
  // clear+add (tier-switch) path below, not a substitute for avoiding
  // redundant calls in the first place (see addToCartAndCheckout).
  function fetchWithRetry(url, options, retries, delayMs) {
    return fetch(url, options).then(function (res) {
      if (!res.ok && (res.status === 429 || res.status >= 500) && retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      return res;
    }, function (err) {
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      throw err;
    });
  }

  // Tracks (client-side only, no server round-trip) which variant this
  // script has already added to the cart this browser session, so a repeat
  // or tier-switch click doesn't need to guess by asking the server first.
  // Shared across every CC-clone product's own interactions.js (same literal
  // key string on every page) rather than a per-product key -- this is what
  // makes the "only one product's items in the cart at once" rule below
  // actually cross-product: this page can tell whether the cart's currently
  // tracked item belongs to a DIFFERENT product page, not just a different
  // tier of this same one. Uses localStorage, not sessionStorage -- confirmed
  // live 2026-08-30 that sessionStorage's per-TAB scoping let three tabs each
  // add a different product independently (each tab saw no prior tracked
  // item, so each took the zero-call fresh-add path with nothing to clear).
  // localStorage is shared across every tab on this origin, so the same
  // check now sees what any tab already added. Still not a real-time
  // server-truth check (deliberately -- that would mean a network call on
  // every click, the exact class of change that caused the 2026-08-28 429
  // incident below), so a customer manually editing /cart in one tab while
  // another tab is mid-purchase is still a narrow gap, but two-tab browsing
  // (the case that actually broke) is now covered.
  // Reads the REAL current cart from Shopify (not a client-side flag) so
  // the fresh-add / repeat-click / tier-switch decision below is always
  // based on what's actually in the cart, not on what we think we added
  // last time. This replaces a localStorage flag that used to be set
  // BEFORE the native form-post's outcome was known -- any add that
  // failed server-side (e.g. a 422 from a missing/stale selling_plan)
  // still left the flag saying "already added," so the next click skipped
  // straight to /checkout with an EMPTY real cart, and Shopify silently
  // redirects an empty-cart checkout to the store's home page (confirmed
  // live on rnmn-cc-clone-interactions.js, 2026-08-31 -- this is exactly
  // what "ATC redirects to the home page" turned out to be). A GET to
  // /cart.js is safe to make on every click: the bot-detection issue the
  // EMERGENCY FIX below exists to avoid is specifically about repeated
  // cart-WRITE calls (/cart/add.js, /cart/clear.js), not reads.
  function getCartState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (res) { return res.json(); });
  }

  // EMERGENCY FIX (2026-08-28): this page sells mutually-exclusive bundle
  // tiers as separate variants, not add-on quantities -- clearing before
  // adding prevents the cart from ever holding more than one tier's line
  // item at once. The previous version unconditionally called clear.js
  // THEN add.js on every single click -- two Shopify AJAX Cart API calls
  // per click, even on a customer's first, completely normal click, with
  // no retry on failure. Confirmed live in production: Shopify's cart
  // endpoints apply bot-detection that can 429 after as few as 2-3 calls
  // in a short window (documented regression --
  // community.shopify.dev/t/aggressive-bot-detection-with-429-errors-ajax-cart-api),
  // and the doubled call volume here made that far more likely to trip on
  // real customers, surfacing as a broken, unrecoverable ADD TO CART
  // button. Fixed to match a standard Shopify ATC button: a fresh click
  // this session makes exactly ONE cart call (add). Clicking the SAME
  // tier again makes ZERO calls (already in cart, straight to checkout).
  // Only an actual tier SWITCH makes two calls (clear, then add) -- the one
  // case that genuinely needs it. Every remaining call also retries once
  // or twice with a backoff on a 429/5xx so a transient rate-limit blip
  // never reaches the customer as a broken button.
  // Submits a REAL, native <form method="post" action="/cart/add"> --
  // a genuine full-page browser navigation, not a fetch()/XHR AJAX call.
  // Shopify's bot-detection issue documented above is specifically an
  // "AJAX Cart API" problem (fetch calls to the .js-suffixed endpoints);
  // a classic form POST to the non-.js /cart/add endpoint is the same
  // mechanism every plain Shopify "Buy Now" button has used for years and
  // is not the pattern that detection watches for. The return_to field is
  // a native Shopify feature: it redirects straight to /checkout after a
  // successful add, with no custom JS involved in that step at all.
  function submitAddToCartForm(variantId, sellingPlanId) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';
    var fields = [['id', variantId], ['quantity', 1], ['items[1][id]', SHIPPING_PROTECTION_VARIANT_ID], ['items[1][quantity]', 1], ['return_to', '/checkout']];
    if (sellingPlanId) fields.push(['selling_plan', sellingPlanId]);
    fields.forEach(function (pair) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = pair[0];
      input.value = pair[1];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function addToCartAndCheckout(e) {
    e.preventDefault();
    var btn = e.currentTarget;
    var checked = getCheckedRadio();
    var variantId = checked ? VARIANT_MAP[checked.value] : null;
    if (!variantId) {
      alert('Please select an offer above.');
      return;
    }
    setAtcLoading(btn, true);
    // Cart-read and selling-plan lookup are independent -- run them in
    // parallel rather than chaining, so a required-selling-plan tier isn't
    // any slower to click than a plain one-time-purchase tier.
    Promise.all([getCartState(), getRequiredSellingPlan(variantId)]).then(function (results) {
      var cart = results[0];
      var sellingPlanId = results[1];
      var items = cart.items || [];
      var hasThisVariant = items.some(function (item) { return item.id === variantId; });
      if (hasThisVariant) {
        // Already in the (real, server-confirmed) cart -- zero AJAX
        // cart-write calls, straight to checkout.
        window.location.href = '/checkout';
        return;
      }
      var hasOtherTier = items.some(function (item) {
        return item.id !== variantId && item.id !== SHIPPING_PROTECTION_VARIANT_ID;
      });
      if (!hasOtherTier) {
        // Common case (nothing else of ours in the cart): zero AJAX
        // cart-write calls -- straight to the native form-post add+redirect.
        submitAddToCartForm(variantId, sellingPlanId);
        return;
      }
      // Tier switch (rare): one AJAX call to clear the previous tier, then
      // the same native form-post add+redirect for the new one -- still
      // avoids ever chaining two AJAX cart-write calls back to back.
      fetchWithRetry('/cart/clear.js', { method: 'POST' }, 2, 1000)
        .then(function () {
          submitAddToCartForm(variantId, sellingPlanId);
        })
        .catch(function () {
          setAtcLoading(btn, false);
          alert('Could not update your cart. Please try again.');
        });
    }).catch(function () {
      // Couldn't even read the cart/selling-plan state -- fail safe with a
      // fresh, no-selling-plan add rather than getting stuck (worst case:
      // an unnecessary but harmless duplicate-tier line item, or a 422 if
      // the tier genuinely needed a plan -- never a silent no-op).
      submitAddToCartForm(variantId, null);
    });
  }

  // Generic accordion: thumbSelector click toggles .active on the closest
  // blockSelector ancestor and shows/hides its contentSelector child.
  // Covers FAQ, ingredient tabs, and "Inside Each Scoop" blocks -- none of
  // these have a JS-free CSS reveal rule (only icon-rotate/border styling
  // is class-driven), so the show/hide itself has to be done in JS.
  function wireAccordion(thumbSelector, blockSelector, contentSelector) {
    document.querySelectorAll(thumbSelector).forEach(function (thumb) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () {
        var block = thumb.closest(blockSelector);
        if (!block) return;
        var content = block.querySelector(contentSelector);
        var opening = !block.classList.contains('active');
        block.classList.toggle('active', opening);
        if (content) content.style.display = opening ? 'block' : 'none';
      });
    });
  }

  function wireNutritionPopup() {
    var trigger = document.querySelector('.main_product-nutrition-info');
    var popup = document.querySelector('.nutrition_popup-outer');
    if (!trigger || !popup) return;
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function () {
      popup.style.display = 'flex';
    });
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.classList.contains('nutrition_popup-close')) {
        popup.style.display = 'none';
      }
    });
  }

  // Mobile hero image slider: thumbnail click scrolls the viewport to that
  // slide, and the active thumb/dot stays in sync while the user swipes.
  function wireMobileSlider() {
    var viewport = document.getElementById('csViewport');
    var thumbs = document.querySelectorAll('.cs-thumb');
    var slides = document.querySelectorAll('.cs-slide');
    var dotsContainer = document.getElementById('csDots');
    if (!viewport || !slides.length) return;

    if (dotsContainer && !dotsContainer.children.length) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'cs-dot' + (i === 0 ? ' cs-dot-active' : '');
        dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
        dot.addEventListener('click', function () { scrollToSlide(i); });
        dotsContainer.appendChild(dot);
      });
    }
    var dots = dotsContainer ? dotsContainer.querySelectorAll('.cs-dot') : [];

    function setActiveIndex(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('cs-thumb-active', idx === i); });
      dots.forEach(function (d, idx) { d.classList.toggle('cs-dot-active', idx === i); });
    }

    function scrollToSlide(i) {
      var slide = slides[i];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      setActiveIndex(i);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', function () { scrollToSlide(i); });
    });

    var scrollTimeout;
    viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var i = Math.round(viewport.scrollLeft / viewport.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        setActiveIndex(i);
      }, 100);
    });
  }

  // Judge.me review photo thumbnails: the static HTML snapshot ships each
  // one stuck in Judge.me's own "jdgm--loading" placeholder state (a grey
  // broken-image icon) because the real thumbnail URL only gets swapped in
  // by Judge.me's live API-backed lazy-load, which never fires against a
  // static snapshot. The real URL is already present on the link's
  // data-mfp-src attribute, so just promote it straight into the img src.
  // A MutationObserver keeps this applied as Judge.me re-renders the
  // review list (pagination, sorting, filtering).
  function fixReviewPhotoThumbnails(root) {
    (root || document).querySelectorAll('.jdgm-rev__pic-link.jdgm--loading').forEach(function (link) {
      var realSrc = link.getAttribute('data-mfp-src');
      var img = link.querySelector('.jdgm-rev__pic-img');
      if (!realSrc || !img) return;
      img.src = realSrc;
      link.classList.remove('jdgm--loading');
    });
  }

  function wireReviewPhotoFix() {
    var widg = document.querySelector('.jdgm-rev-widg');
    if (!widg) return;
    fixReviewPhotoThumbnails(widg);
    var observer = new MutationObserver(function () {
      fixReviewPhotoThumbnails(widg);
    });
    observer.observe(widg, { childList: true, subtree: true });
  }


  function wireShipDate() {
    var el = document.querySelector('.col_pp_delivery__Date');
    if (!el) return;
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var t = new Date();
    t.setDate(t.getDate() + 5);
    el.textContent = days[t.getDay()] + ', ' + t.getDate() + ' ' + months[t.getMonth()];
  }

  document.addEventListener('DOMContentLoaded', function () {
    wireShipDate();
    syncActiveStyling();
    document.querySelectorAll('.product-selector_atc').forEach(function (btn) {
      btn.addEventListener('click', addToCartAndCheckout);
    });
    wireAccordion('.product_faq-thumb', '.product_faq-box', '.product_faq-content');
    wireAccordion('.product_tab-thumb', '.product_tab-block', '.product_tab-content');
    wireAccordion('.product-inside_block-thumb', '.product-inside_block', '.product-inside_block-content');
    wireNutritionPopup();
    wireMobileSlider();
    wireReviewPhotoFix();
  });
})();
